<div class="order-list">
	<div class="order-list__filters">
		<epic-card [collapseState]="!!entityId">
			<span start>{{ textFilter }}</span>
			<epic-icon-button
				(click)="handleClearFilters()"
				[text]="textRemoveFilter"
				end
				hoverColor="var(--color__danger)"
				iconHoverColor="var(--color__white)"
				iconHoverQuerySelector="path"
				iconName="broom" />
			<ng-container *ngIf="!refreshFilters && !isColumnFilters; then filtersContainer" />
		</epic-card>
	</div>
	@if (!showKanban) {
		<div class="order-list__list">
			<div class="order-list__head">
				<div class="order-list__left">
					<h2
						class="order-list__title font-weight__semibold"
						i18n>
						Orders list
					</h2>
					@if (aclCanCreateOrder()) {
						<epic-button
							[epic-tooltip]="textAddNewOrder"
							[epic-tooltip-classes]="['epic-tooltip--square']"
							[classes]="['epic-button--square']"
							(click)="openAddOrderModal()">
							<epic-icon name="plus-mini" />
						</epic-button>
					}
				</div>
				<div class="order-list__right">
					<epic-pagination [pagination]="pagination" />
					<epic-icon-button
						(click)="changeFiltersStyle()"
						iconHoverQuerySelector="path"
						[text]="textFiltersStyle"
						[background]="'var(--color__white)'"
						[hoverColor]="'var(--color__dark)'"
						[tooltipTextColor]="'var(--color__white)'"
						[iconHoverColor]="'var(--color__white)'"
						[iconName]="'filter-add'" />
					<epic-icon-button
						(click)="exportOrdersToCSV()"
						iconHoverQuerySelector="path"
						[text]="'Export to CSV'"
						[background]="'var(--color__white)'"
						[hoverColor]="'var(--color__dark)'"
						[tooltipTextColor]="'var(--color__white)'"
						[iconHoverColor]="'var(--color__white)'"
						[iconName]="'csv'"></epic-icon-button>
					<epic-icon-button
						iconHoverQuerySelector="path"
						[text]="textShowKanban"
						[background]="'var(--color__white)'"
						[hoverColor]="'var(--color__dark)'"
						[tooltipTextColor]="'var(--color__white)'"
						[iconHoverColor]="'var(--color__white)'"
						[iconName]="'kanban-icon'"
						(click)="toggleView()" />
					@if (aclCanUpdateOrders()) {
						<epic-icon-button
							(click)="changeOrderStatus()"
							[hoverColor]="'var(--color__dark)'"
							[iconHoverColor]="'var(--color__white)'"
							[text]="textChangeStatusOrders"
							[tooltipTextColor]="'var(--color__white)'"
							iconName="status-change" />
					}
					@if (aclCanUpdateOrders()) {
						<epic-icon-button
							(click)="changeAssignationOrder()"
							[hoverColor]="'var(--color__dark)'"
							[iconHoverColor]="'var(--color__white)'"
							[text]="textChangeAssignationOrders"
							[tooltipTextColor]="'var(--color__white)'"
							iconName="user-check" />
					}

					@if (aclCanDeleteOrder()) {
						<epic-icon-button
							(click)="handleOrderDelete()"
							[text]="textDeleteSelectedOrdersButton"
							hoverColor="var(--color__danger)"
							iconHoverColor="var(--color__white)"
							iconHoverQuerySelector="path"
							iconName="delete" />
					}
				</div>
			</div>
			<div class="order-list__table">
				<epic-table
					#tableComponent
					(queryChange)="queryChanged($event)"
					[generateCheckboxes]="aclCanUpdateOrders() || aclCanDeleteOrder()"
					(checkboxesChange)="checkboxesChanged($event)"
					(tableViewInit)="setTableViewSortValue()"
					[enableAdditionalScroll]="true"
					class="contractors-page-table">
					<tr
						class="font__small"
						table-headers
						table-row-data
						[is-header-checkbox]="aclCanUpdateOrders() || aclCanDeleteOrder()">
						<epic-table-header class="font-align__center">
							<span i18n="@@ordinalNumber">No.</span>
						</epic-table-header>
						<epic-table-header
							[filterOpen]="isColumnFilters"
							dataKey="number">
							<span i18n>Order number</span>
							<epic-form-field table-filter>
								<epic-input
									[control]="filters.controls.orderNumber"
									[placeholder]="textSearch"
									(keydown.enter)="handleTableFilters(true)"
									(onBlur)="handleTableFilters(true)" />
							</epic-form-field>
						</epic-table-header>
						<epic-table-header
							sortable
							[filterOpen]="isColumnFilters"
							dataKey="container_number">
							<span i18n>Container number</span>
							<epic-form-field table-filter>
								<epic-input
									[control]="filters.controls.containerNumber"
									[placeholder]="textSearch"
									(keydown.enter)="handleTableFilters(true)"
									(onBlur)="handleTableFilters(true)" />
							</epic-form-field>
						</epic-table-header>
						<epic-table-header
							class="filter--min-width"
							sortable
							[filterOpen]="isColumnFilters"
							dataKey="entering_port_date">
							<span i18n>Entering port date</span>
							<epic-form-field
								table-filter
								datePicker>
								<epic-input
									type="date"
									[control]="filters.controls.enteringPortDate"
									[placeholder]="textSearch"
									(modelChange)="handleTableFilters()" />
							</epic-form-field>
						</epic-table-header>
						@if (aclCanReadContractors()) {
							<epic-table-header
								sortable
								dataKey="entity"
								[filterOpen]="isColumnFilters">
								<span i18n>Contractor</span>
								<epic-form-field table-filter>
									<epic-autocomplete
										[multiSelect]="true"
										[placeholder]="textSearchRecipient"
										(searchChange)="fetchEntities($event)"
										(afterClosing)="handleTableFilters(false, 'entity')"
										[control]="filters.controls.entity"
										[focused]="!!filters.controls.entity.value"
										[isClearVisible]="false"
										[customSelectedValues]="true"
										class="form__element-7">
										<div
											class="epic-select__custom-values"
											selected-values>
											<span
												*ngFor="let entity of filters.controls.entity.value"
												class="epic-select__value-round"
												>{{ entity.name }}</span
											>
										</div>
										@for (entity of entities.items; track entity.id) {
											<epic-option
												[value]="entity"
												[selected]="false"
												class="epic_select__option">
												{{ entity.name }}
											</epic-option>
										}
									</epic-autocomplete>
								</epic-form-field>
							</epic-table-header>
						}
						<epic-table-header
							sortable
							[filterOpen]="isColumnFilters"
							class="table-column__sm"
							dataKey="comments">
							<span i18n>Comments</span>
							<epic-form-field table-filter>
								<epic-input
									[control]="filters.controls.comments"
									[placeholder]="textSearch"
									(keydown.enter)="handleTableFilters(true)"
									(onBlur)="handleTableFilters(true)" />
							</epic-form-field>
						</epic-table-header>
						<epic-table-header
							sortable
							[filterOpen]="isColumnFilters"
							dataKey="take_date">
							<span i18n>Order date</span>
							<epic-form-field-group
								table-filter
								class="form__element-12"
								datePicker>
								<epic-input
									[focused]="!!filters.controls.takeDateFrom.value"
									[control]="filters.controls.takeDateFrom"
									type="date"
									[placeholder]="textDateFrom" />
								<epic-input
									[focused]="!!filters.controls.takeDateTo.value"
									[control]="filters.controls.takeDateTo"
									type="date"
									[placeholder]="textDateTo" />
							</epic-form-field-group>
						</epic-table-header>
						<epic-table-header
							sortable
							[filterOpen]="isColumnFilters"
							dataKey="pickup_terminal">
							<span i18n>Terminal</span>
							<epic-form-field table-filter>
								<epic-autocomplete
									(searchChange)="fetchTerminal($event)"
									[control]="filters.controls.terminal"
									(modelChange)="handleTableFilters()"
									[customSelectedValues]="true">
									@if (!!filters.controls.terminal.value) {
										<div
											class="epic-select__custom-values"
											selected-values>
											@if (filters.controls.terminal.value) {
												<span class="epic-select__value-round">{{ filters.controls.terminal.value.name }}</span>
											}
										</div>
									}
									@for (terminal of pickupTerminals; track terminal.id) {
										<epic-option [value]="terminal">
											{{ terminal.name }}
										</epic-option>
									}
								</epic-autocomplete>
							</epic-form-field>
						</epic-table-header>
						<epic-table-header
							sortable
							[filterOpen]="isColumnFilters"
							dataKey="container_bl">
							<span i18n>Number BL</span>
							<epic-form-field table-filter>
								<epic-input
									[control]="filters.controls.blNumber"
									[placeholder]="textSearch"
									(keydown.enter)="handleTableFilters(true)"
									(onBlur)="handleTableFilters(true)" />
							</epic-form-field>
						</epic-table-header>
						@if (aclCanReadStatuses()) {
							<epic-table-header
								sortable
								[filterOpen]="isColumnFilters"
								dataKey="status">
								<span i18n>Status</span>
								<epic-form-field table-filter>
									<epic-select
										[control]="filters.controls.status"
										[multiSelect]="true"
										(afterClosing)="handleTableFilters(false, 'status')"
										[isClearVisible]="false"
										[customSelectedValues]="true">
										@if (!!filters.controls.status.value?.length) {
											<div
												class="epic-select__custom-values"
												selected-values>
												@for (status of filters.controls.status.value; track status) {
													<span class="epic-select__value-round">{{ getItemTranslation(status) }}</span>
												}
											</div>
										}
										@for (status of statusesFilters; track status) {
											<epic-option
												[isDivider]="!!status.dividerText"
												[selected]="isOptionSelected(status)"
												[value]="status.status">
												@if (status.status) {
													<div class="option">
														<div
															class="option__cube"
															[style.background-color]="status.status?.colour"></div>
														<span>{{ getItemTranslation(status.status) }}</span>
													</div>
												} @else {
													{{ status.dividerText }}
												}
											</epic-option>
										}
									</epic-select>
								</epic-form-field>
							</epic-table-header>
						}
						@if (aclCanReadUsers()) {
							<epic-table-header
								sortable
								[filterOpen]="isColumnFilters"
								dataKey="assigned_to">
								<span i18n>Assigned to</span>
								<epic-form-field table-filter>
									<epic-autocomplete
										[multiSelect]="true"
										[placeholder]="textSearchRecipient"
										(searchChange)="fetchUsers($event)"
										(afterClosing)="handleTableFilters(false, 'assignedTo')"
										[isClearVisible]="false"
										[control]="filters.controls.takenBy"
										[focused]="!!filters.controls.takenBy.value"
										[customSelectedValues]="true"
										class="form__element-7">
										<div
											class="epic-select__custom-values"
											selected-values>
											<span
												*ngFor="let user of filters.controls.takenBy.value"
												class="epic-select__value-round"
												>{{ user.first_name }} {{ user.last_name }}</span
											>
										</div>
										@for (user of users.items; track user.id) {
											<epic-option
												[value]="user"
												[selected]="false"
												class="epic_select__option">
												{{ user.first_name }} {{ user.last_name }}
											</epic-option>
										}
									</epic-autocomplete>
								</epic-form-field>
							</epic-table-header>
						}
						<epic-table-header class="table-column__xs" />
					</tr>
					@for (item of model.items; track $index) {
						<tr
							[class]="{
								marked_row: checkDateAndDsk(item),
								font__small: true,
								'order-list__list': true,
								'focus--border': getLocalStorageScroll?.scrollTargetId === item.id,
							}"
							[table-row-data]="item">
							<td class="font-align__center">
								{{
									$index +
										1 +
										(pagination.currentPage! > 1 ? pagination.currentPage! - 1 : 0) * (pagination.perPage || 0)
								}}
							</td>
							<td>
								<div class="row row--center order-list__header-clickable">
									<div class="name_row">
										<span
											(click)="navigateToDetails(item)"
											class="clickable"
											>{{ item.number }}</span
										>
										@if (item.status?.is_blocked) {
											<div>
												<epic-icon
													[epic-tooltip-position]="'left'"
													[epic-tooltip]="textBlockade"
													name="lock" />
											</div>
										}
									</div>
									<epic-icon-button
										(click)="openInNewWindow(item)"
										[tooltipDirection]="'left'"
										[hoverColor]="'var(--color__dark)'"
										[iconHoverColor]="'var(--color__white)'"
										[iconName]="'window'"
										[text]="textOpenNewWindow"
										[tooltipTextColor]="'var(--color__white)'"
										iconHoverQuerySelector="path" />
								</div>
								<span class="status_line">
									<span class="status_line--padding__tag-none">
										@if (aclCanReadConveyanceTypes()) {
											@if (aclCanUpdateOrders()) {
												<epic-tag
													*ngIf="item.conveyance_type"
													(onClick)="changeConveyanceType(item)"
													[epic-tooltip]="textConveyanceType"
													[classes]="['tag--small']"
													[background]="item.conveyance_type?.colour"
													[hoverColor]="item.conveyance_type?.colour"
													[text]="getItemTranslation(item.conveyance_type)"
													[color]="getTextColor(item.conveyance_type?.colour)" />
											} @else {
												<epic-tag
													*ngIf="item.conveyance_type"
													[classes]="['tag--small', 'tag--readonly']"
													[epic-tooltip]="textConveyanceType"
													[background]="item.conveyance_type?.colour"
													[hoverColor]="item.conveyance_type?.colour"
													[text]="getItemTranslation(item.conveyance_type)"
													[color]="getTextColor(item.conveyance_type?.colour)" />
											}
										}
									</span>
									<span>
										@if (aclCanReadStatuses() && aclCanReadInvoices() && aclCanReadCostInvoices()) {
											@if (aclCanUpdateOrders()) {
												<epic-tag
													*ngIf="item.order_payment_status"
													(onClick)="changePaymentStatus(item)"
													[epic-tooltip]="textOrderPaymentStatus"
													[classes]="['tag--small']"
													[background]="item.order_payment_status?.colour"
													[hoverColor]="item.order_payment_status?.colour"
													[text]="getItemTranslation(item.order_payment_status)"
													[color]="getTextColor(item.order_payment_status?.colour)" />
											} @else {
												<epic-tag
													*ngIf="item.order_payment_status"
													[classes]="['tag--small']"
													[epic-tooltip]="textOrderPaymentStatus"
													[background]="item.order_payment_status?.colour"
													[hoverColor]="item.order_payment_status?.colour"
													[text]="getItemTranslation(item.order_payment_status)"
													[color]="getTextColor(item.order_payment_status?.colour)" />
											}
										}
									</span>
								</span>
							</td>
							<td>
								<div class="row row--center order-list__header-clickable">
									<div
										(click)="navigateToDetails(item)"
										class="name_row-container clickable font-weight__bold">
										@if (item.container_number) {
											{{ item.container_number }}
										} @else {
											{{ item.package_count }}<span i18n>PC</span>/{{ item.container_weight }}<span i18n>kg</span>
										}
									</div>
									@if (item.container_number) {
										<epic-icon-button
											(click)="copyToClipboard(item.container_number)"
											[tooltipDirection]="'right'"
											[hoverColor]="'var(--color__dark)'"
											[iconHoverColor]="'var(--color__white)'"
											[iconName]="'copy'"
											[text]="textCopy"
											[tooltipTextColor]="'var(--color__white)'"
											class="copy-button"
											iconHoverQuerySelector="path" />
									}
									@if (!item.has_delivery_confirmation) {
										<epic-icon-button
											(click)="openDeliveryConfirmationModal(item)"
											[tooltipDirection]="'left'"
											[hoverColor]="'var(--color__dark)'"
											[iconHoverColor]="'var(--color__white)'"
											[iconName]="'deliveryx'"
											[text]="textHasDeliveryConfirmation"
											[tooltipTextColor]="'var(--color__white)'"
											iconHoverQuerySelector="path" />
									} @else {
										<epic-icon-button
											(click)="openDeliveryConfirmationModal(item)"
											[tooltipDirection]="'left'"
											[hoverColor]="'var(--color__dark)'"
											[iconHoverColor]="'var(--color__white)'"
											[iconName]="'delivery+'"
											[text]="textHasDeliveryConfirmation"
											[tooltipTextColor]="'var(--color__white)'"
											iconHoverQuerySelector="path" />
									}
								</div>
								<span class="status_line">
									<span class="status_line--padding__tag-none">
										@if (aclCanReadStatuses()) {
											@if (aclCanUpdateOrders()) {
												<epic-tag
													*ngIf="item.container_logistic_status"
													(onClick)="changeLogisticStatus(item)"
													[classes]="['tag--small']"
													[epic-tooltip]="textContainerLogisticStatus"
													[background]="item.container_logistic_status?.colour"
													[hoverColor]="item.container_logistic_status?.colour"
													[text]="getItemTranslation(item.container_logistic_status)"
													[color]="getTextColor(item.container_logistic_status?.colour)" />
											} @else {
												<epic-tag
													*ngIf="item.container_logistic_status"
													[classes]="['tag--small', 'tag--readonly']"
													[epic-tooltip]="textContainerLogisticStatus"
													[background]="item.container_logistic_status?.colour"
													[hoverColor]="item.container_logistic_status?.colour"
													[text]="getItemTranslation(item.container_logistic_status)"
													[color]="getTextColor(item.container_logistic_status?.colour)" />
											}
										}
									</span>
									<span class="status_line--margin__left-none">
										@if (aclCanReadStatuses()) {
											@if (aclCanUpdateOrders()) {
												<epic-tag
													*ngIf="item.container_clearance_status"
													(onClick)="changeClearanceStatus(item)"
													[classes]="['tag--small']"
													[epic-tooltip]="textContainerCustomsStatus"
													[background]="item.container_clearance_status?.colour"
													[hoverColor]="item.container_clearance_status?.colour"
													[text]="getItemTranslation(item.container_clearance_status)"
													[color]="getTextColor(item.container_clearance_status?.colour)" />
											} @else {
												<epic-tag
													*ngIf="item.container_clearance_status"
													[classes]="['tag--small', 'tag--readonly']"
													[epic-tooltip]="textContainerCustomsStatus"
													[background]="item.container_clearance_status?.colour"
													[hoverColor]="item.container_clearance_status?.colour"
													[text]="getItemTranslation(item.container_clearance_status)"
													[color]="getTextColor(item.container_clearance_status?.colour)" />
											}
										}
									</span>
								</span>
							</td>
							<td
								class="clickable"
								(click)="navigateToDetails(item)">
								{{ item.entering_port_date | date: 'dd.MM.yyyy' }}
							</td>
							@if (aclCanReadContractors()) {
								<td
									class="clickable"
									(click)="goToContractor(item.entity?.contractor!)">
									{{ showEntityName(item.entity) }}
								</td>
							}
							<td
								class="clickable table-column__sm"
								[epic-tooltip]="item.comment ?? undefined"
								[epic-tooltip-classes]="['epic-tooltip--white-space']">
								<div
									class="clickable comments_column"
									(click)="navigateToDetails(item)">
									{{ item.comment }}
								</div>
							</td>
							<td
								class="clickable"
								(click)="navigateToDetails(item)">
								{{ item.take_date | date: 'dd.MM.yyyy HH:mm:ss' }}
							</td>
							<td
								class="clickable"
								(click)="navigateToDetails(item)">
								{{ item.pickup_terminal?.name }}
							</td>
							<td>
								<div class="row order-list__header-clickable-small">
									<div
										(click)="navigateToDetails(item)"
										class="name_row-small clickable">
										{{ item.container_bl }}
									</div>
									@if (item.container_bl) {
										<epic-icon-button
											(click)="copyToClipboard(item.container_bl)"
											[tooltipDirection]="'right'"
											[hoverColor]="'var(--color__dark)'"
											[iconHoverColor]="'var(--color__white)'"
											[iconName]="'copy'"
											[text]="textCopy"
											[tooltipTextColor]="'var(--color__white)'"
											class="copy-button"
											iconHoverQuerySelector="path" />
									}
								</div>
							</td>
							@if (aclCanReadStatuses()) {
								<td>
									@if (aclCanUpdateOrders()) {
										<epic-tag
											(onClick)="changeOrderStatus(item)"
											[classes]="['tag--small']"
											[background]="item.status?.colour"
											[hoverColor]="item.status?.colour"
											[text]="getItemTranslation(item.status)"
											[color]="getTextColor(item.status?.colour)" />
									} @else {
										<epic-tag
											[classes]="['tag--small', 'tag--readonly']"
											[background]="item.status?.colour"
											[hoverColor]="item.status?.colour"
											[text]="getItemTranslation(item.status)"
											[color]="getTextColor(item.status?.colour)" />
									}
								</td>
							}
							<td>{{ item.assigned_to?.first_name }} {{ item.assigned_to?.last_name }}</td>
							<!-- @if (aclCanReadUsers()) {
								<td>{{ item.taken_by?.first_name }} {{ item.taken_by?.last_name }}</td>
							} -->
							<td class="order-list__buttons-cell">
								<div class="order-list__buttons">
									@if (aclCanUpdateOrders()) {
										<epic-icon-button
											(click)="changeAssignationOrder(item)"
											[hoverColor]="'var(--color__dark)'"
											[iconHoverColor]="'var(--color__white)'"
											[text]="textChangeAssignation"
											[tooltipTextColor]="'var(--color__white)'"
											iconName="user-check" />

										<epic-icon-button
											(click)="handleContractorChange(item, $index)"
											[text]="textChangeOfContractor"
											hoverColor="var(--color__dark)"
											iconHoverColor="var(--color__white)"
											iconName="user-edit" />
									}

									<epic-icon-button
										(click)="navigateToDetails(item)"
										[hoverColor]="'var(--color__dark)'"
										[iconHoverColor]="'var(--color__white)'"
										[iconName]="'eye'"
										[text]="textOrderPreview"
										[tooltipTextColor]="'var(--color__white)'"
										iconHoverQuerySelector="path" />

									<epic-icon-button
										(click)="createNewOrderFromValues(item)"
										[text]="textCreateOrderTemplate"
										iconHoverQuerySelector="path"
										[hoverColor]="'var(--color__black)'"
										[tooltipTextColor]="'var(--color__white)'"
										[iconName]="'submit-save'"
										[iconHoverColor]="'var(--color__white)'" />

									@if (aclCanDeleteOrder()) {
										<epic-icon-button
											(click)="handleOrderDelete(item)"
											[text]="textDelete"
											hoverColor="var(--color__danger)"
											iconHoverColor="var(--color__white)"
											iconHoverQuerySelector="path"
											iconName="delete" />
									}
								</div>
							</td>
						</tr>
					}
				</epic-table>
			</div>
			<div class="order-list__foot">
				<epic-pagination [pagination]="pagination" />
				<epic-icon-button
					(click)="scrollToOrders()"
					[background]="'var(--color__white)'"
					[hoverColor]="'var(--color__white)'"
					[iconHoverColor]="'var(--color__dark)'"
					[iconName]="'arrow-up'" />
			</div>
		</div>
	} @else {
		<order-kanban
			[columns]="columns"
			[statuses]="statuses"
			[filters]="filters"
			[contractorId]="contractorId"
			(refreshList)="refreshList()"
			(changeView)="toggleView()" />
	}
</div>

<ng-template #filtersContainer>
	<div class="filters orders-filters">
		<div class="orders-filters__fields form form__element-12">
			<div class="orders-filters__search form__element-3">
				<epic-form-field [text]="'&#160;'">
					<epic-input
						(keyup.enter)="handleFilters()"
						[control]="filters.controls.search"
						[focused]="!!filters.controls.search.value"
						[placeholder]="textEnterPhrase" />
				</epic-form-field>
			</div>
			<div class="orders-filters__date form__element-3 form">
				<epic-form-field-group
					[text]="textOrderDate"
					class="form__element-12"
					datePicker>
					<epic-input
						[control]="filters.controls.takeDateFrom"
						[focused]="!!filters.controls.takeDateFrom.value"
						[placeholder]="textDateFrom"
						type="date" />
					<epic-input
						[control]="filters.controls.takeDateTo"
						[focused]="!!filters.controls.takeDateTo.value"
						[placeholder]="textDateTo"
						type="date" />
				</epic-form-field-group>
			</div>
			<div class="orders-filters__transport form__element-3">
				@if (aclCanReadConveyanceTypes()) {
					<epic-form-field [text]="textTransport">
						<epic-select
							[multiSelect]="true"
							[placeholder]="textSearchTransport"
							[control]="filters.controls.conveyanceType"
							[focused]="!!filters.controls.conveyanceType.value"
							[customSelectedValues]="true"
							class="form__element-7">
							<div
								class="epic-select__custom-values"
								selected-values>
								<span
									*ngFor="let conveyance of filters.controls.conveyanceType.value"
									class="epic-select__value-round"
									>{{ getItemTranslation(conveyance) }}</span
								>
							</div>
							@for (type of conveyanceTypes; track type.id) {
								<epic-option
									[value]="type"
									[selected]="false"
									class="epic_select__option">
									{{ getItemTranslation(type) }}
								</epic-option>
							}
						</epic-select>
					</epic-form-field>
				}
			</div>
			<div class="orders-filters__recipient form__element-3">
				@if (aclCanReadUsers()) {
					<epic-form-field [text]="textOrderRecipient">
						<epic-autocomplete
							[multiSelect]="true"
							[placeholder]="textSearchRecipient"
							(searchChange)="fetchUsers($event)"
							[control]="filters.controls.takenBy"
							[focused]="!!filters.controls.takenBy.value"
							[customSelectedValues]="true"
							class="form__element-7">
							<div
								class="epic-select__custom-values"
								selected-values>
								<span
									*ngFor="let user of filters.controls.takenBy.value"
									class="epic-select__value-round"
									>{{ user.first_name }} {{ user.last_name }}</span
								>
							</div>
							@for (user of users.items; track user.id) {
								<epic-option
									[value]="user"
									[selected]="false"
									class="epic_select__option">
									{{ user.first_name }} {{ user.last_name }}
								</epic-option>
							}
						</epic-autocomplete>
					</epic-form-field>
				}
			</div>
			@if (!contractorId && !entityId) {
				<div class="orders-filters__recipient form__element-3">
					@if (aclCanReadContractors()) {
						<epic-form-field [text]="textContractorGroup">
							<epic-autocomplete
								[multiSelect]="true"
								[placeholder]="textSearchRecipient"
								(searchChange)="fetchContractors($event)"
								[control]="filters.controls.contractor"
								[focused]="!!filters.controls.contractor.value"
								[customSelectedValues]="true"
								class="form__element-7">
								<div
									class="epic-select__custom-values"
									selected-values>
									<span
										*ngFor="let contractor of filters.controls.contractor.value"
										class="epic-select__value-round"
										>{{ contractor.name }}</span
									>
								</div>
								@for (contractor of contractors.items; track contractor.id) {
									<epic-option
										[value]="contractor"
										[selected]="false"
										class="epic_select__option">
										{{ contractor.name }}
									</epic-option>
								}
							</epic-autocomplete>
						</epic-form-field>
					}
				</div>
			}
			@if (!entityId) {
				<div class="orders-filters__recipient form__element-3">
					@if (aclCanReadEntities()) {
						<epic-form-field [text]="textEntity">
							<epic-autocomplete
								[multiSelect]="true"
								[placeholder]="textSearchRecipient"
								(searchChange)="fetchEntities($event)"
								[control]="filters.controls.entity"
								[focused]="!!filters.controls.entity.value"
								[customSelectedValues]="true"
								class="form__element-7">
								<div
									class="epic-select__custom-values"
									selected-values>
									<span
										*ngFor="let entity of filters.controls.entity.value"
										class="epic-select__value-round"
										>{{ entity.name }}</span
									>
								</div>
								@for (entity of entities.items; track entity.id) {
									<epic-option
										[value]="entity"
										[selected]="false"
										class="epic_select__option">
										{{ entity.name }}
									</epic-option>
								}
							</epic-autocomplete>
						</epic-form-field>
					}
				</div>
			}

			<div class="orders-filters__status form__element-3">
				@if (aclCanReadStatuses()) {
					<epic-form-field [text]="textStatus">
						<epic-select
							[control]="filters.controls.status"
							[multiSelect]="true"
							[customSelectedValues]="true">
							@if (!!filters.controls.status.value?.length) {
								<div
									class="epic-select__custom-values"
									selected-values>
									@for (status of filters.controls.status.value; track status) {
										<span class="epic-select__value-round">{{ getItemTranslation(status) }}</span>
									}
								</div>
							}
							@for (status of statusesFilters; track status) {
								<epic-option
									[isDivider]="!!status.dividerText"
									[selected]="isOptionSelected(status)"
									[value]="status.status">
									@if (status.status) {
										<div class="option">
											<div
												class="option__cube"
												[style.background-color]="status.status?.colour"></div>
											<span>{{ getItemTranslation(status.status) }}</span>
										</div>
									} @else {
										{{ status.dividerText }}
									}
								</epic-option>
							}
						</epic-select>
					</epic-form-field>
				}
			</div>
			<div class="form__element-3">
				<epic-form-field [text]="textHasDeliveryConfirmation">
					<epic-select
						[control]="filters.controls.delivery_confirmation"
						[customSelectedValues]="true">
						<div
							class="epic-select__custom-values"
							selected-values>
							<div
								*ngIf="filters.controls.delivery_confirmation.value === 'selected'"
								class="epic-select__selected"
								i18n>
								Yes
							</div>
							<div
								*ngIf="filters.controls.delivery_confirmation.value === 'unselected'"
								class="epic-select__selected"
								i18n>
								No
							</div>
						</div>
						<epic-option
							[selected]="filters.controls.delivery_confirmation.value === 'selected'"
							[value]="'selected'">
							<span i18n>Yes</span>
						</epic-option>
						<epic-option
							[selected]="filters.controls.delivery_confirmation.value === 'unselected'"
							[value]="'unselected'">
							<span i18n>No</span>
						</epic-option>
					</epic-select>
				</epic-form-field>
			</div>
			<div class="form__element-3">
				<epic-form-field-group
					[text]="textEnterPortDate"
					class="form__element-12"
					datePicker>
					<epic-input
						[control]="filters.controls.enteringPortDateFrom"
						[focused]="!!filters.controls.enteringPortDateFrom.value"
						[placeholder]="textEnterPortDateFrom"
						type="date" />
					<epic-input
						[control]="filters.controls.enteringPortDateTo"
						[focused]="!!filters.controls.enteringPortDateTo.value"
						[placeholder]="textEnterPortDateTo"
						type="date" />
				</epic-form-field-group>
			</div>
			<div class="form__element-3">
				<epic-form-field [text]="textComments">
					<epic-input
						[control]="filters.controls.comments"
						[placeholder]="textSearch" />
				</epic-form-field>
			</div>
			<div class="form__element-3">
				<epic-form-field [text]="textTerminal">
					<epic-autocomplete
						(searchChange)="fetchTerminal($event)"
						[control]="filters.controls.terminal"
						[customSelectedValues]="true">
						@if (!!filters.controls.terminal.value) {
							<div
								class="epic-select__custom-values"
								selected-values>
								@if (filters.controls.terminal.value) {
									<span class="epic-select__value-round">{{ filters.controls.terminal.value.name }}</span>
								}
							</div>
						}
						@for (terminal of pickupTerminals; track terminal.id) {
							<epic-option [value]="terminal">
								{{ terminal.name }}
							</epic-option>
						}
					</epic-autocomplete>
				</epic-form-field>
			</div>
			<div class="form__element-3">
				<epic-form-field [text]="textWithoutCustomsTask">
					<epic-select
						[control]="filters.controls.without_customs_task"
						[customSelectedValues]="true">
						<div
							class="epic-select__custom-values"
							selected-values>
							<div
								*ngIf="filters.controls.without_customs_task.value === 'selected'"
								class="epic-select__selected"
								i18n>
								Yes
							</div>
							<div
								*ngIf="filters.controls.without_customs_task.value === 'unselected'"
								class="epic-select__selected"
								i18n>
								No
							</div>
						</div>
						<epic-option
							[selected]="filters.controls.without_customs_task.value === 'selected'"
							[value]="'selected'">
							<span i18n>Yes</span>
						</epic-option>
						<epic-option
							[selected]="filters.controls.without_customs_task.value === 'unselected'"
							[value]="'unselected'">
							<span i18n>No</span>
						</epic-option>
					</epic-select>
				</epic-form-field>
			</div>
			<div class="orders-filters__status form__element-12">
				<div class="orders-filters__submit">
					<epic-button
						(click)="handleFilters()"
						size="large">
						<epic-icon name="kanban" />
						<span i18n>SHOW ORDERS</span>
					</epic-button>
				</div>
			</div>
		</div>
	</div>
</ng-template>
